import React, { useEffect } from "react"

// import { BrowserRouter as Router } from "react-router-dom"
import { QueryClient, QueryClientProvider } from "react-query"
import { AuthProvider } from "./context/Auth"
import { ConfirmationDialogProvider } from "./context/ConfirmDialog"
import { motion, AnimatePresence } from "framer-motion"
// import { createNotificationContext } from "react-notification-provider"
import ReactGA from "react-ga4"
import mixpanel from "mixpanel-browser"
import { Toaster } from "react-hot-toast"

// import EmptyComponent from "./components/EmptyComponent"
import Loading from "./components/Loading"

import Routes from "./router"

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            staleTime: Infinity,
        },
    },
})

ReactGA.initialize(process.env.REACT_APP_GA_KEY)

// Near entry of your product, init Mixpanel
mixpanel.init(process.env.REACT_APP_MIXPANEL_API_KEY, {
    debug: true,
    track_pageview: true,
    persistence: "localStorage",
})

function App() {
    // useEffect(() => {
    //     initGA()
    //     ReactGA.pageview(window.location.pathname)
    // }, [])

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: window.location.pathname })
    }, [])

    return (
        <div>
            <React.Suspense fallback={<Loading />}>
                <ConfirmationDialogProvider>
                    <AuthProvider>
                        {/* <Router> */}
                        <QueryClientProvider client={queryClient}>
                            <Routes />
                        </QueryClientProvider>
                        {/* </Router> */}
                    </AuthProvider>
                </ConfirmationDialogProvider>
                <Toaster position="top-right" reverseOrder={false} />
            </React.Suspense>
        </div>
    )
}

export default App
